exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".page-footer-wrap{text-align:center}.page-footer-wrap .text-wrap{display:block;width:890px;height:20px;margin-left:550px;overflow:hidden}.page-footer-wrap .text-wrap span{animation:textAni 12s linear infinite;display:inline-block;font-size:12px;line-height:20px;color:#cde3ff;opacity:.45}.text-outer{overflow:hidden;text-align:right;color:rgba(93,104,166,.3);font-size:12px}.text-outer .corp-right{float:right;color:#cde3ff;opacity:.3;margin-right:27px;line-height:20px}@keyframes textAni{0%{transform:translate(900px)}to{transform:translate(-900px)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-d4729518!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/layouts/page-footer/index.vue
// module id = 179
// module chunks = 0